import React from "react";
import axios from 'axios';

const FileUpload = (props) =>{

    const upload = async (files) =>{
        if(files == null) return;

        const formData = new FormData();
        formData.append('uploadFile', files[0]);
        const {data} = await axios.post('upload', formData);

        props.uploaded(data.url);

    }
    return (
        <label className="btn btn-primary">
            upload <input type="file" hidden onChange={e =>upload(e.target.files)}/>
        </label>
    );
}

export default FileUpload;